function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module utils/dom/position
 */
import global from './global';
import Rect from './rect';
import getPositionedAncestor from './getpositionedancestor';
import getBorderWidths from './getborderwidths';
import { isFunction } from 'lodash-es';
/**
 * Calculates the `position: absolute` coordinates of a given element so it can be positioned with respect to the
 * target in the visually most efficient way, taking various restrictions like viewport or limiter geometry
 * into consideration.
 *
 *		// The element which is to be positioned.
 *		const element = document.body.querySelector( '#toolbar' );
 *
 *		// A target to which the element is positioned relatively.
 *		const target = document.body.querySelector( '#container' );
 *
 *		// Finding the optimal coordinates for the positioning.
 *		const { left, top, name } = getOptimalPosition( {
 *			element: element,
 *			target: target,
 *
 * 			// The algorithm will chose among these positions to meet the requirements such
 * 			// as "limiter" element or "fitInViewport", set below. The positions are considered
 * 			// in the order of the array.
 *			positions: [
 *				//
 *			 	//	[ Target ]
 *				//	+-----------------+
 *				//	|     Element     |
 *				//	+-----------------+
 *				//
 *				targetRect => ( {
 *					top: targetRect.bottom,
 *					left: targetRect.left,
 *					name: 'mySouthEastPosition'
 *				} ),
 *
 *				//
 *				//	+-----------------+
 *				//	|     Element     |
 *				//	+-----------------+
 *				//	[ Target ]
 *				//
 *				( targetRect, elementRect ) => ( {
 *					top: targetRect.top - elementRect.height,
 *					left: targetRect.left,
 *					name: 'myNorthEastPosition'
 *				} )
 *			],
 *
 *			// Find a position such guarantees the element remains within visible boundaries of <body>.
 *			limiter: document.body,
 *
 *			// Find a position such guarantees the element remains within visible boundaries of the browser viewport.
 *			fitInViewport: true
 *		} );
 *
 *		// The best position which fits into document.body and the viewport. May be useful
 *		// to set proper class on the `element`.
 *		console.log( name ); // -> "myNorthEastPosition"
 *
 *		// Using the absolute coordinates which has been found to position the element
 *		// as in the diagram depicting the "myNorthEastPosition" position.
 *		element.style.top = top;
 *		element.style.left = left;
 *
 * @param {module:utils/dom/position~Options} options Positioning options object.
 * @returns {module:utils/dom/position~Position}
 */

export function getOptimalPosition(_ref) {
  var element = _ref.element,
      target = _ref.target,
      positions = _ref.positions,
      limiter = _ref.limiter,
      fitInViewport = _ref.fitInViewport;

  // If the {@link module:utils/dom/position~Options#target} is a function, use what it returns.
  // https://github.com/ckeditor/ckeditor5-utils/issues/157
  if (isFunction(target)) {
    target = target();
  } // If the {@link module:utils/dom/position~Options#limiter} is a function, use what it returns.
  // https://github.com/ckeditor/ckeditor5-ui/issues/260


  if (isFunction(limiter)) {
    limiter = limiter();
  }

  var positionedElementAncestor = getPositionedAncestor(element);
  var elementRect = new Rect(element);
  var targetRect = new Rect(target);
  var bestPositionRect;
  var bestPositionName; // If there are no limits, just grab the very first position and be done with that drama.

  if (!limiter && !fitInViewport) {
    var _getPositionNameAndRe = getPositionNameAndRect(positions[0], targetRect, elementRect);

    var _getPositionNameAndRe2 = _slicedToArray(_getPositionNameAndRe, 2);

    bestPositionName = _getPositionNameAndRe2[0];
    bestPositionRect = _getPositionNameAndRe2[1];
  } else {
    var limiterRect = limiter && new Rect(limiter).getVisible();
    var viewportRect = fitInViewport && new Rect(global.window);
    var bestPosition = getBestPositionNameAndRect(positions, {
      targetRect: targetRect,
      elementRect: elementRect,
      limiterRect: limiterRect,
      viewportRect: viewportRect
    }); // If there's no best position found, i.e. when all intersections have no area because
    // rects have no width or height, then just use the first available position.

    var _ref2 = bestPosition || getPositionNameAndRect(positions[0], targetRect, elementRect);

    var _ref3 = _slicedToArray(_ref2, 2);

    bestPositionName = _ref3[0];
    bestPositionRect = _ref3[1];
  }

  var absoluteRectCoordinates = getAbsoluteRectCoordinates(bestPositionRect);

  if (positionedElementAncestor) {
    absoluteRectCoordinates = shiftRectCoordinatesDueToPositionedAncestor(absoluteRectCoordinates, positionedElementAncestor);
  }

  return {
    left: absoluteRectCoordinates.left,
    top: absoluteRectCoordinates.top,
    name: bestPositionName
  };
} // For given position function, returns a corresponding `Rect` instance.
//
// @private
// @param {Function} position A function returning {@link module:utils/dom/position~Position}.
// @param {utils/dom/rect~Rect} targetRect A rect of the target.
// @param {utils/dom/rect~Rect} elementRect A rect of positioned element.
// @returns {Array|null} An array containing position name and its Rect (or null if position should be ignored).

function getPositionNameAndRect(position, targetRect, elementRect) {
  var positionData = position(targetRect, elementRect);

  if (!positionData) {
    return null;
  }

  var left = positionData.left,
      top = positionData.top,
      name = positionData.name;
  return [name, elementRect.clone().moveTo(left, top)];
} // For a given array of positioning functions, returns such that provides the best
// fit of the `elementRect` into the `limiterRect` and `viewportRect`.
//
// @private
//
// @param {Object} options
// @param {module:utils/dom/position~Options#positions} positions Functions returning {@link module:utils/dom/position~Position}
// to be checked, in the order of preference.
// @param {Object} options
// @param {utils/dom/rect~Rect} options.targetRect A rect of the {@link module:utils/dom/position~Options#target}.
// @param {utils/dom/rect~Rect} options.elementRect A rect of positioned {@link module:utils/dom/position~Options#element}.
// @param {utils/dom/rect~Rect} options.limiterRect A rect of the {@link module:utils/dom/position~Options#limiter}.
// @param {utils/dom/rect~Rect} options.viewportRect A rect of the viewport.
//
// @returns {Array} An array containing the name of the position and it's rect.


function getBestPositionNameAndRect(positions, options) {
  var elementRect = options.elementRect,
      viewportRect = options.viewportRect; // This is when element is fully visible.

  var elementRectArea = elementRect.getArea(); // Let's calculate intersection areas for positions. It will end early if best match is found.

  var processedPositions = processPositionsToAreas(positions, options); // First let's check all positions that fully fit in the viewport.

  if (viewportRect) {
    var processedPositionsInViewport = processedPositions.filter(function (_ref4) {
      var viewportIntersectArea = _ref4.viewportIntersectArea;
      return viewportIntersectArea === elementRectArea;
    }); // Try to find best position from those which fit completely in viewport.

    var bestPositionData = getBestOfProcessedPositions(processedPositionsInViewport, elementRectArea);

    if (bestPositionData) {
      return bestPositionData;
    }
  } // Either there is no viewportRect or there is no position that fits completely in the viewport.


  return getBestOfProcessedPositions(processedPositions, elementRectArea);
} // For a given array of positioning functions, calculates intersection areas for them.
//
// Note: If some position fully fits into the `limiterRect`, it will be returned early, without further consideration
// of other positions.
//
// @private
//
// @param {module:utils/dom/position~Options#positions} positions Functions returning {@link module:utils/dom/position~Position}
// to be checked, in the order of preference.
// @param {Object} options
// @param {utils/dom/rect~Rect} options.targetRect A rect of the {@link module:utils/dom/position~Options#target}.
// @param {utils/dom/rect~Rect} options.elementRect A rect of positioned {@link module:utils/dom/position~Options#element}.
// @param {utils/dom/rect~Rect} options.limiterRect A rect of the {@link module:utils/dom/position~Options#limiter}.
// @param {utils/dom/rect~Rect} options.viewportRect A rect of the viewport.
//
// @returns {Array.<Object>} Array of positions with calculated intersection areas. Each item is an object containing:
// * {String} positionName Name of position.
// * {utils/dom/rect~Rect} positionRect Rect of position.
// * {Number} limiterIntersectArea Area of intersection of the position with limiter part that is in the viewport.
// * {Number} viewportIntersectArea Area of intersection of the position with viewport.


function processPositionsToAreas(positions, _ref5) {
  var targetRect = _ref5.targetRect,
      elementRect = _ref5.elementRect,
      limiterRect = _ref5.limiterRect,
      viewportRect = _ref5.viewportRect;
  var processedPositions = []; // This is when element is fully visible.

  var elementRectArea = elementRect.getArea();

  var _iterator = _createForOfIteratorHelper(positions),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var position = _step.value;
      var positionData = getPositionNameAndRect(position, targetRect, elementRect);

      if (!positionData) {
        continue;
      }

      var _positionData = _slicedToArray(positionData, 2),
          positionName = _positionData[0],
          positionRect = _positionData[1];

      var limiterIntersectArea = 0;
      var viewportIntersectArea = 0;

      if (limiterRect) {
        if (viewportRect) {
          // Consider only the part of the limiter which is visible in the viewport. So the limiter is getting limited.
          var limiterViewportIntersectRect = limiterRect.getIntersection(viewportRect);

          if (limiterViewportIntersectRect) {
            // If the limiter is within the viewport, then check the intersection between that part of the
            // limiter and actual position.
            limiterIntersectArea = limiterViewportIntersectRect.getIntersectionArea(positionRect);
          }
        } else {
          limiterIntersectArea = limiterRect.getIntersectionArea(positionRect);
        }
      }

      if (viewportRect) {
        viewportIntersectArea = viewportRect.getIntersectionArea(positionRect);
      }

      var processedPosition = {
        positionName: positionName,
        positionRect: positionRect,
        limiterIntersectArea: limiterIntersectArea,
        viewportIntersectArea: viewportIntersectArea
      }; // If a such position is found that element is fully contained by the limiter then, obviously,
      // there will be no better one, so finishing.

      if (limiterIntersectArea === elementRectArea) {
        return [processedPosition];
      }

      processedPositions.push(processedPosition);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return processedPositions;
} // For a given array of processed position data (with calculated Rects for positions and intersection areas)
// returns such that provides the best fit of the `elementRect` into the `limiterRect` and `viewportRect` at the same time.
//
// **Note**: It will return early if some position fully fits into the `limiterRect`.
//
// @private
// @param {Array.<Object>} Array of positions with calculated intersection areas (in order of preference).
// Each item is an object containing:
//
//	* {String} positionName Name of position.
//	* {utils/dom/rect~Rect} positionRect Rect of position.
//	* {Number} limiterIntersectArea Area of intersection of the position with limiter part that is in the viewport.
//	* {Number} viewportIntersectArea Area of intersection of the position with viewport.
//
// @param {Number} elementRectArea Area of positioned {@link module:utils/dom/position~Options#element}.
// @returns {Array|null} An array containing the name of the position and it's rect, or null if not found.


function getBestOfProcessedPositions(processedPositions, elementRectArea) {
  var maxFitFactor = 0;
  var bestPositionRect;
  var bestPositionName;

  var _iterator2 = _createForOfIteratorHelper(processedPositions),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref7 = _step2.value;
      var positionName = _ref7.positionName;
      var positionRect = _ref7.positionRect;
      var limiterIntersectArea = _ref7.limiterIntersectArea;
      var viewportIntersectArea = _ref7.viewportIntersectArea;

      // If a such position is found that element is fully container by the limiter then, obviously,
      // there will be no better one, so finishing.
      if (limiterIntersectArea === elementRectArea) {
        return [positionName, positionRect];
      } // To maximize both viewport and limiter intersection areas we use distance on viewportIntersectArea
      // and limiterIntersectArea plane (without sqrt because we are looking for max value).


      var fitFactor = Math.pow(viewportIntersectArea, 2) + Math.pow(limiterIntersectArea, 2);

      if (fitFactor > maxFitFactor) {
        maxFitFactor = fitFactor;
        bestPositionRect = positionRect;
        bestPositionName = positionName;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return bestPositionRect ? [bestPositionName, bestPositionRect] : null;
} // For a given absolute Rect coordinates object and a positioned element ancestor, it returns an object with
// new Rect coordinates that make up for the position and the scroll of the ancestor.
//
// This is necessary because while Rects (and DOMRects) are relative to the browser's viewport, their coordinates
// are used in real–life to position elements with `position: absolute`, which are scoped by any positioned
// (and scrollable) ancestors.
//
// @private
//
// @param {Object} absoluteRectCoordinates An object with absolute rect coordinates.
// @param {Object} absoluteRectCoordinates.top
// @param {Object} absoluteRectCoordinates.left
// @param {HTMLElement} positionedElementAncestor An ancestor element that should be considered.
//
// @returns {Object} An object corresponding to `absoluteRectCoordinates` input but with values shifted
// to make up for the positioned element ancestor.


function shiftRectCoordinatesDueToPositionedAncestor(_ref8, positionedElementAncestor) {
  var left = _ref8.left,
      top = _ref8.top;
  var ancestorPosition = getAbsoluteRectCoordinates(new Rect(positionedElementAncestor));
  var ancestorBorderWidths = getBorderWidths(positionedElementAncestor); // (https://github.com/ckeditor/ckeditor5-ui-default/issues/126)
  // If there's some positioned ancestor of the panel, then its `Rect` must be taken into
  // consideration. `Rect` is always relative to the viewport while `position: absolute` works
  // with respect to that positioned ancestor.

  left -= ancestorPosition.left;
  top -= ancestorPosition.top; // (https://github.com/ckeditor/ckeditor5-utils/issues/139)
  // If there's some positioned ancestor of the panel, not only its position must be taken into
  // consideration (see above) but also its internal scrolls. Scroll have an impact here because `Rect`
  // is relative to the viewport (it doesn't care about scrolling), while `position: absolute`
  // must compensate that scrolling.

  left += positionedElementAncestor.scrollLeft;
  top += positionedElementAncestor.scrollTop; // (https://github.com/ckeditor/ckeditor5-utils/issues/139)
  // If there's some positioned ancestor of the panel, then its `Rect` includes its CSS `borderWidth`
  // while `position: absolute` positioning does not consider it.
  // E.g. `{ position: absolute, top: 0, left: 0 }` means upper left corner of the element,
  // not upper-left corner of its border.

  left -= ancestorBorderWidths.left;
  top -= ancestorBorderWidths.top;
  return {
    left: left,
    top: top
  };
} // DOMRect (also Rect) works in a scroll–independent geometry but `position: absolute` doesn't.
// This function converts Rect to `position: absolute` coordinates.
//
// @private
// @param {utils/dom/rect~Rect} rect A rect to be converted.
// @returns {Object} Object containing `left` and `top` properties, in absolute coordinates.


function getAbsoluteRectCoordinates(_ref9) {
  var left = _ref9.left,
      top = _ref9.top;
  var _global$window = global.window,
      scrollX = _global$window.scrollX,
      scrollY = _global$window.scrollY;
  return {
    left: left + scrollX,
    top: top + scrollY
  };
}
/**
 * The `getOptimalPosition()` helper options.
 *
 * @interface module:utils/dom/position~Options
 */

/**
 * Element that is to be positioned.
 *
 * @member {HTMLElement} #element
 */

/**
 * Target with respect to which the `element` is to be positioned.
 *
 * @member {HTMLElement|Range|ClientRect|Rect|Function} #target
 */

/**
 * An array of functions which return {@link module:utils/dom/position~Position} relative
 * to the `target`, in the order of preference.
 *
 * **Note**: If a function returns `null`, it is ignored by the `getOptimalPosition()`.
 *
 * @member {Array.<Function>} #positions
 */

/**
 * When set, the algorithm will chose position which fits the most in the
 * limiter's bounding rect.
 *
 * @member {HTMLElement|Range|ClientRect|Rect|Function} #limiter
 */

/**
 * When set, the algorithm will chose such a position which fits `element`
 * the most inside visible viewport.
 *
 * @member {Boolean} #fitInViewport
 */

/**
 * An object describing a position in `position: absolute` coordinate
 * system, along with position name.
 *
 * @typedef {Object} module:utils/dom/position~Position
 *
 * @property {Number} top Top position offset.
 * @property {Number} left Left position offset.
 * @property {String} name Name of the position.
 */